import React, { useState, useEffect } from "react";
import axios from "axios";
import "./VangalGallerySection.css";
import { FaTimes, FaArrowLeft, FaArrowRight } from "react-icons/fa";

const VangalGallerySection = () => {
  const [galleryImages, setGalleryImages] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(null);

  // Fetch images from backend
  useEffect(() => {
    const fetchImages = async () => {
      try {
        const res = await axios.get("https://vangal-backend.onrender.com/api/infrastructure");
        setGalleryImages(res.data);
      } catch (err) {
        console.error("Error fetching images:", err);
      }
    };

    fetchImages();
  }, []);

  const openLightbox = (index) => setCurrentIndex(index);
  const closeLightbox = () => setCurrentIndex(null);

  const showPrev = (e) => {
    e.stopPropagation();
    setCurrentIndex((prev) => (prev === 0 ? galleryImages.length - 1 : prev - 1));
  };

  const showNext = (e) => {
    e.stopPropagation();
    setCurrentIndex((prev) => (prev === galleryImages.length - 1 ? 0 : prev + 1));
  };

  return (
    <section className="vg-gallery-wrapper">
      <div className="vg-gallery-container">
        <h2 className="vg-gallery-title anim anim-top">Advanced Production Infrastructure</h2>

        {/* Masonry Grid */}
        <div className="vg-gallery-masonry anim anim-bottom">
          {galleryImages.map((imgObj, index) => (
            <div
              key={imgObj.id}
              className="vg-gallery-item"
              onClick={() => openLightbox(index)}
            >
              <img src={imgObj.img} alt="gallery" />
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {currentIndex !== null && galleryImages[currentIndex] && (
        <div className="vg-lightbox-overlay" onClick={closeLightbox}>
          <FaTimes className="vg-lightbox-close" onClick={closeLightbox} />
          <FaArrowLeft className="vg-lightbox-prev" onClick={showPrev} />
          <div className="vg-lightbox-content">
            <img src={galleryImages[currentIndex].img} alt="large view" />
          </div>
          <FaArrowRight className="vg-lightbox-next" onClick={showNext} />
        </div>
      )}
    </section>
  );
};

export default VangalGallerySection;
